import { useCallback } from "react";

import { useLocation } from "react-router-dom";

import { useUser } from "@components/user-context";

import { useShortLinksContext } from "./provider";

export const useShortlinkToClipboard = () => {
  const { createShortlink } = useShortLinksContext();
  const location = useLocation();
  const { user } = useUser();
  const shortlinkCopyToClipboard = useCallback(async () => {
    const url = location.pathname.split("/").slice(2).join("/");
    const shortlink = await createShortlink(`${url}${location.search}`);

    const currentUrl = new URL(window.location.href);
    const base = `${currentUrl.protocol}//${currentUrl.host}`;

    await navigator.clipboard.writeText(
      `${base}/${user.displayUserId}/share/${shortlink?.id ?? ""}`,
    );
  }, [createShortlink, location.pathname, location.search, user.displayUserId]);

  return { shortlinkCopyToClipboard };
};
